export default "__VITE_ASSET__83719d5c__"